/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ClaimStatusTemplate,
  ClaimStatusTemplateListResponse,
  CreateClaimStatusTemplateRequest,
  CreateTaskTemplateRequest,
  ErrorEnvelope,
  Problem,
  TaskTemplate,
  TaskTemplateListResponse,
  UpdateClaimStatusTemplateRequest,
  UpdateTaskTemplateRequest,
} from '../models/index';
import {
    ClaimStatusTemplateFromJSON,
    ClaimStatusTemplateToJSON,
    ClaimStatusTemplateListResponseFromJSON,
    ClaimStatusTemplateListResponseToJSON,
    CreateClaimStatusTemplateRequestFromJSON,
    CreateClaimStatusTemplateRequestToJSON,
    CreateTaskTemplateRequestFromJSON,
    CreateTaskTemplateRequestToJSON,
    ErrorEnvelopeFromJSON,
    ErrorEnvelopeToJSON,
    ProblemFromJSON,
    ProblemToJSON,
    TaskTemplateFromJSON,
    TaskTemplateToJSON,
    TaskTemplateListResponseFromJSON,
    TaskTemplateListResponseToJSON,
    UpdateClaimStatusTemplateRequestFromJSON,
    UpdateClaimStatusTemplateRequestToJSON,
    UpdateTaskTemplateRequestFromJSON,
    UpdateTaskTemplateRequestToJSON,
} from '../models/index';

export interface CreateClaimStatusTemplateOperationRequest {
    createClaimStatusTemplateRequest: CreateClaimStatusTemplateRequest;
}

export interface CreateClaimStatusTemplateTaskTemplateRequest {
    id: number;
    createTaskTemplateRequest: CreateTaskTemplateRequest;
}

export interface DeleteClaimStatusTemplateRequest {
    id: number;
}

export interface DeleteClaimStatusTemplateTaskTemplateRequest {
    id: number;
    taskId: number;
}

export interface GetClaimStatusTemplateRequest {
    id: number;
    includeTaskTemplates?: boolean;
}

export interface GetClaimStatusTemplateTaskTemplatesRequest {
    id: number;
}

export interface GetClaimStatusTemplatesRequest {
    includeInactive?: boolean;
    includeTaskTemplates?: boolean;
    pipelineId?: number;
}

export interface UpdateClaimStatusTemplateOperationRequest {
    id: number;
    updateClaimStatusTemplateRequest: UpdateClaimStatusTemplateRequest;
}

export interface UpdateClaimStatusTemplateTaskTemplateRequest {
    id: number;
    taskId: number;
    updateTaskTemplateRequest: UpdateTaskTemplateRequest;
}

/**
 * TemplatesApi - interface
 * 
 * @export
 * @interface TemplatesApiInterface
 */
export interface TemplatesApiInterface {
    /**
     * 
     * @summary Create a new claim status template
     * @param {CreateClaimStatusTemplateRequest} createClaimStatusTemplateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApiInterface
     */
    createClaimStatusTemplateRaw(requestParameters: CreateClaimStatusTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimStatusTemplate>>;

    /**
     * Create a new claim status template
     */
    createClaimStatusTemplate(requestParameters: CreateClaimStatusTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimStatusTemplate>;

    /**
     * 
     * @summary Create a new task template for a status template
     * @param {number} id Status template ID
     * @param {CreateTaskTemplateRequest} createTaskTemplateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApiInterface
     */
    createClaimStatusTemplateTaskTemplateRaw(requestParameters: CreateClaimStatusTemplateTaskTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TaskTemplate>>;

    /**
     * Create a new task template for a status template
     */
    createClaimStatusTemplateTaskTemplate(requestParameters: CreateClaimStatusTemplateTaskTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TaskTemplate>;

    /**
     * Deletes a claim status template. This operation will fail if: - The template is the last active template for the company (every company must have at least one template) - The template is currently in use by any claims  Status templates are soft-deleted (marked as inactive) rather than permanently removed. 
     * @summary Delete a claim status template
     * @param {number} id Status template ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApiInterface
     */
    deleteClaimStatusTemplateRaw(requestParameters: DeleteClaimStatusTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Deletes a claim status template. This operation will fail if: - The template is the last active template for the company (every company must have at least one template) - The template is currently in use by any claims  Status templates are soft-deleted (marked as inactive) rather than permanently removed. 
     * Delete a claim status template
     */
    deleteClaimStatusTemplate(requestParameters: DeleteClaimStatusTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Delete a task template
     * @param {number} id Status template ID
     * @param {number} taskId Task template ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApiInterface
     */
    deleteClaimStatusTemplateTaskTemplateRaw(requestParameters: DeleteClaimStatusTemplateTaskTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete a task template
     */
    deleteClaimStatusTemplateTaskTemplate(requestParameters: DeleteClaimStatusTemplateTaskTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get a claim status template by ID
     * @param {number} id Status template ID
     * @param {boolean} [includeTaskTemplates] Include task templates associated with the status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApiInterface
     */
    getClaimStatusTemplateRaw(requestParameters: GetClaimStatusTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimStatusTemplate>>;

    /**
     * Get a claim status template by ID
     */
    getClaimStatusTemplate(requestParameters: GetClaimStatusTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimStatusTemplate>;

    /**
     * 
     * @summary Get all task templates for a status template
     * @param {number} id Status template ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApiInterface
     */
    getClaimStatusTemplateTaskTemplatesRaw(requestParameters: GetClaimStatusTemplateTaskTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TaskTemplateListResponse>>;

    /**
     * Get all task templates for a status template
     */
    getClaimStatusTemplateTaskTemplates(requestParameters: GetClaimStatusTemplateTaskTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TaskTemplateListResponse>;

    /**
     * 
     * @summary Get all claim status templates
     * @param {boolean} [includeInactive] Include inactive status templates
     * @param {boolean} [includeTaskTemplates] Include task templates associated with each status
     * @param {number} [pipelineId] Filter status templates by workflow pipeline ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApiInterface
     */
    getClaimStatusTemplatesRaw(requestParameters: GetClaimStatusTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimStatusTemplateListResponse>>;

    /**
     * Get all claim status templates
     */
    getClaimStatusTemplates(requestParameters: GetClaimStatusTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimStatusTemplateListResponse>;

    /**
     * 
     * @summary Update a claim status template
     * @param {number} id Status template ID
     * @param {UpdateClaimStatusTemplateRequest} updateClaimStatusTemplateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApiInterface
     */
    updateClaimStatusTemplateRaw(requestParameters: UpdateClaimStatusTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimStatusTemplate>>;

    /**
     * Update a claim status template
     */
    updateClaimStatusTemplate(requestParameters: UpdateClaimStatusTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimStatusTemplate>;

    /**
     * 
     * @summary Update a task template
     * @param {number} id Status template ID
     * @param {number} taskId Task template ID
     * @param {UpdateTaskTemplateRequest} updateTaskTemplateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApiInterface
     */
    updateClaimStatusTemplateTaskTemplateRaw(requestParameters: UpdateClaimStatusTemplateTaskTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TaskTemplate>>;

    /**
     * Update a task template
     */
    updateClaimStatusTemplateTaskTemplate(requestParameters: UpdateClaimStatusTemplateTaskTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TaskTemplate>;

}

/**
 * 
 */
export class TemplatesApi extends runtime.BaseAPI implements TemplatesApiInterface {

    /**
     * Create a new claim status template
     */
    async createClaimStatusTemplateRaw(requestParameters: CreateClaimStatusTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimStatusTemplate>> {
        if (requestParameters['createClaimStatusTemplateRequest'] == null) {
            throw new runtime.RequiredError(
                'createClaimStatusTemplateRequest',
                'Required parameter "createClaimStatusTemplateRequest" was null or undefined when calling createClaimStatusTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claim-status-templates`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateClaimStatusTemplateRequestToJSON(requestParameters['createClaimStatusTemplateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimStatusTemplateFromJSON(jsonValue));
    }

    /**
     * Create a new claim status template
     */
    async createClaimStatusTemplate(requestParameters: CreateClaimStatusTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimStatusTemplate> {
        const response = await this.createClaimStatusTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new task template for a status template
     */
    async createClaimStatusTemplateTaskTemplateRaw(requestParameters: CreateClaimStatusTemplateTaskTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TaskTemplate>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createClaimStatusTemplateTaskTemplate().'
            );
        }

        if (requestParameters['createTaskTemplateRequest'] == null) {
            throw new runtime.RequiredError(
                'createTaskTemplateRequest',
                'Required parameter "createTaskTemplateRequest" was null or undefined when calling createClaimStatusTemplateTaskTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claim-status-templates/{id}/tasks`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateTaskTemplateRequestToJSON(requestParameters['createTaskTemplateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TaskTemplateFromJSON(jsonValue));
    }

    /**
     * Create a new task template for a status template
     */
    async createClaimStatusTemplateTaskTemplate(requestParameters: CreateClaimStatusTemplateTaskTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TaskTemplate> {
        const response = await this.createClaimStatusTemplateTaskTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes a claim status template. This operation will fail if: - The template is the last active template for the company (every company must have at least one template) - The template is currently in use by any claims  Status templates are soft-deleted (marked as inactive) rather than permanently removed. 
     * Delete a claim status template
     */
    async deleteClaimStatusTemplateRaw(requestParameters: DeleteClaimStatusTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteClaimStatusTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claim-status-templates/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes a claim status template. This operation will fail if: - The template is the last active template for the company (every company must have at least one template) - The template is currently in use by any claims  Status templates are soft-deleted (marked as inactive) rather than permanently removed. 
     * Delete a claim status template
     */
    async deleteClaimStatusTemplate(requestParameters: DeleteClaimStatusTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteClaimStatusTemplateRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a task template
     */
    async deleteClaimStatusTemplateTaskTemplateRaw(requestParameters: DeleteClaimStatusTemplateTaskTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteClaimStatusTemplateTaskTemplate().'
            );
        }

        if (requestParameters['taskId'] == null) {
            throw new runtime.RequiredError(
                'taskId',
                'Required parameter "taskId" was null or undefined when calling deleteClaimStatusTemplateTaskTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claim-status-templates/{id}/tasks/{taskId}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"taskId"}}`, encodeURIComponent(String(requestParameters['taskId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a task template
     */
    async deleteClaimStatusTemplateTaskTemplate(requestParameters: DeleteClaimStatusTemplateTaskTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteClaimStatusTemplateTaskTemplateRaw(requestParameters, initOverrides);
    }

    /**
     * Get a claim status template by ID
     */
    async getClaimStatusTemplateRaw(requestParameters: GetClaimStatusTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimStatusTemplate>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getClaimStatusTemplate().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['includeTaskTemplates'] != null) {
            queryParameters['includeTaskTemplates'] = requestParameters['includeTaskTemplates'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claim-status-templates/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimStatusTemplateFromJSON(jsonValue));
    }

    /**
     * Get a claim status template by ID
     */
    async getClaimStatusTemplate(requestParameters: GetClaimStatusTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimStatusTemplate> {
        const response = await this.getClaimStatusTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all task templates for a status template
     */
    async getClaimStatusTemplateTaskTemplatesRaw(requestParameters: GetClaimStatusTemplateTaskTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TaskTemplateListResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getClaimStatusTemplateTaskTemplates().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claim-status-templates/{id}/tasks`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TaskTemplateListResponseFromJSON(jsonValue));
    }

    /**
     * Get all task templates for a status template
     */
    async getClaimStatusTemplateTaskTemplates(requestParameters: GetClaimStatusTemplateTaskTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TaskTemplateListResponse> {
        const response = await this.getClaimStatusTemplateTaskTemplatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all claim status templates
     */
    async getClaimStatusTemplatesRaw(requestParameters: GetClaimStatusTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimStatusTemplateListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['includeInactive'] != null) {
            queryParameters['includeInactive'] = requestParameters['includeInactive'];
        }

        if (requestParameters['includeTaskTemplates'] != null) {
            queryParameters['includeTaskTemplates'] = requestParameters['includeTaskTemplates'];
        }

        if (requestParameters['pipelineId'] != null) {
            queryParameters['pipelineId'] = requestParameters['pipelineId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claim-status-templates`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimStatusTemplateListResponseFromJSON(jsonValue));
    }

    /**
     * Get all claim status templates
     */
    async getClaimStatusTemplates(requestParameters: GetClaimStatusTemplatesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimStatusTemplateListResponse> {
        const response = await this.getClaimStatusTemplatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a claim status template
     */
    async updateClaimStatusTemplateRaw(requestParameters: UpdateClaimStatusTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimStatusTemplate>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateClaimStatusTemplate().'
            );
        }

        if (requestParameters['updateClaimStatusTemplateRequest'] == null) {
            throw new runtime.RequiredError(
                'updateClaimStatusTemplateRequest',
                'Required parameter "updateClaimStatusTemplateRequest" was null or undefined when calling updateClaimStatusTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claim-status-templates/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateClaimStatusTemplateRequestToJSON(requestParameters['updateClaimStatusTemplateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimStatusTemplateFromJSON(jsonValue));
    }

    /**
     * Update a claim status template
     */
    async updateClaimStatusTemplate(requestParameters: UpdateClaimStatusTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimStatusTemplate> {
        const response = await this.updateClaimStatusTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a task template
     */
    async updateClaimStatusTemplateTaskTemplateRaw(requestParameters: UpdateClaimStatusTemplateTaskTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TaskTemplate>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateClaimStatusTemplateTaskTemplate().'
            );
        }

        if (requestParameters['taskId'] == null) {
            throw new runtime.RequiredError(
                'taskId',
                'Required parameter "taskId" was null or undefined when calling updateClaimStatusTemplateTaskTemplate().'
            );
        }

        if (requestParameters['updateTaskTemplateRequest'] == null) {
            throw new runtime.RequiredError(
                'updateTaskTemplateRequest',
                'Required parameter "updateTaskTemplateRequest" was null or undefined when calling updateClaimStatusTemplateTaskTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claim-status-templates/{id}/tasks/{taskId}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"taskId"}}`, encodeURIComponent(String(requestParameters['taskId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateTaskTemplateRequestToJSON(requestParameters['updateTaskTemplateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TaskTemplateFromJSON(jsonValue));
    }

    /**
     * Update a task template
     */
    async updateClaimStatusTemplateTaskTemplate(requestParameters: UpdateClaimStatusTemplateTaskTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TaskTemplate> {
        const response = await this.updateClaimStatusTemplateTaskTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
